import {
  Navigate,
  type RouteObject,
  RouterProvider,
  createBrowserRouter,
  useParams,
} from 'react-router-dom';
import { ErrorPage } from 'src/components/ErrorPage';
import { RootView } from 'src/views/RootView';
import { adminRoutes } from './admin.routes';

// Redirect component for old /timing/* URLs to /leaderboard/*
const TimingRedirect = () => {
  const { eventSlug } = useParams();
  return <Navigate to={`/leaderboard/${eventSlug || ''}`} replace />;
};

export const routes: Array<RouteObject> = [
  // Redirect old timing URLs to leaderboard
  // TODO: remove after 03-2026
  {
    path: '/timing/:eventSlug',
    element: <TimingRedirect />,
  },
  {
    path: '/',
    element: <RootView />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'auth/login',
        lazy: async () => {
          const comp = await import('../views/LoginView');
          return { Component: comp.LoginView };
        },
      },
      {
        path: 'auth/logout',
        lazy: async () => {
          const comp = await import('../views/LogoutView');
          return { Component: comp.LogoutView };
        },
      },
      {
        path: 'auth/register',
        lazy: async () => {
          const comp = await import('../views/RegisterView');
          return { Component: comp.RegisterView };
        },
      },
      {
        path: 'auth/reset-password',
        lazy: async () => {
          const comp = await import('../views/ResetPasswordView');
          return { Component: comp.ResetPasswordView };
        },
      },
      {
        path: 'auth/forgot-password',
        lazy: async () => {
          const comp = await import('../views/ForgotPasswordView');
          return { Component: comp.ForgotPasswordView };
        },
      },
      {
        path: 'auth/confirm-email',
        lazy: async () => {
          const comp = await import('../views/ConfirmEmailView');
          return { Component: comp.ConfirmEmailView };
        },
      },
      {
        path: 'tracker/:trackerId',
        lazy: async () => {
          const comp = await import('../admin/views/TrackerLandingView');
          return { Component: comp.TrackerLandingView };
        },
      },
      {
        path: 'upload',
        lazy: async () => {
          const comp = await import('../admin/views/UploadLandingView');
          return { Component: comp.UploadLandingView };
        },
      },
      {
        path: 'app',
        lazy: async () => {
          const comp = await import('../views/CustomAppLandingView');
          return { Component: comp.CustomAppLandingView };
        },
      },
      {
        path: 'app/redeem_key',
        lazy: async () => {
          const comp = await import('../views/RedeemKeyLandingView');
          return { Component: comp.RedeemKeyLandingView };
        },
      },
      {
        path: 'app/:appIdentifier',
        lazy: async () => {
          const comp = await import('../views/CustomAppLandingView');
          return { Component: comp.CustomAppLandingView };
        },
      },
      {
        path: 'app/:appIdentifier/redeem_key',
        lazy: async () => {
          const comp = await import('../views/RedeemKeyLandingView');
          return { Component: comp.RedeemKeyLandingView };
        },
      },
      {
        path: ':appIdentifier/redeem_key',
        lazy: async () => {
          const comp = await import('../views/RedeemKeyLandingView');
          return { Component: comp.RedeemKeyLandingView };
        },
      },
      {
        path: 'orgaApp/scanSession',
        lazy: async () => {
          const comp = await import('../views/OrgaAppView');
          return { Component: comp.OrgaAppView };
        },
      },
      {
        path: 'safemap/:eventSlug',
        lazy: async () => {
          const comp = await import('../views/SafemapView');
          return { Component: comp.SafemapView };
        },
        children: [
          {
            index: true,
            lazy: async () => {
              const { SafemapScreen } = await import('../components/Safemap');
              return { Component: SafemapScreen };
            },
          },
        ],
      },
      ...adminRoutes,
    ],
  },
];

const router = createBrowserRouter(routes);

export const MainRouter = () => {
  return <RouterProvider router={router} />;
};
